import { render, staticRenderFns } from "./PrepareToSendModal.vue?vue&type=template&id=32a4f00e&scoped=true&"
import script from "./PrepareToSendModal.vue?vue&type=script&lang=js&"
export * from "./PrepareToSendModal.vue?vue&type=script&lang=js&"
import style0 from "./PrepareToSendModal.vue?vue&type=style&index=0&id=32a4f00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4f00e",
  null
  
)

export default component.exports